export default "__VITE_ASSET___G9QE8j6__"